<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bUh49D/tc-custom/9783985314546.jpg?1702956174052" alt="This image is the cover for the book Allan Quatermains Abenteuer Die heilige Blume, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Allan Quatermains Abenteuer Die heilige Blume, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Bruder John, der seit Jahren in Afrika unterwegs ist, vertraut dem bekannten Großwildjäger Allan Quatermain eine riesige und seltene Orchidee an, die größte, die je gefunden wurde. Allan Quatermain kommt mit der Blume nach England und trifft dort auf Mr. Stephen Somers. Aufgrund einer Verwechslung bei einer Auktion zahlt Somers am Ende eine riesige Summe für eine andere besonders seltene Blume. Sein Vater willigt zwar ein, die Kosten für die Blume zu übernehmen, aber er enterbt auch seinen Sohn. Stephen Somers beschließt, die Blume zu verkaufen und damit eine Expedition nach Afrika zu finanzieren, um ein lebendes Exemplar der riesigen Orchidee zu bergen, die Allan mitgebracht hat. Während dieser Expedition in den Süden Afrikas treffen sie auf arabische Sklavenhändler, Kriegerstämme, Kannibalen und einen riesigen Gorilla.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">Sir Henry Rider Haggard (* 22. Juni 1856 in Bradenham Hall, Norfolk, Großbritannien; † 14. Mai 1925 in London) war ein britischer Schriftsteller und Vertreter des englischen Abenteuerromans des 19. Jahrhunderts. Sein bekanntestes Werk ist King Solomon’s Mines (dt. König Salomos Schatzkammer oder König Salomons Diamanten). In der englischsprachigen Welt ist er als H. Rider Haggard bekannt.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?640301d6